module.exports = __webpack_public_path__ + "img/icon_sale_blue.620ab7c6.svg";